/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { createFeatureSelector, createSelector } from '@ngrx/store';

import { Breakpoint } from '../../../../../breakpoints/config';
import { BreakpointState, breakpointFeatureKey } from './breakpoint.reducer';

export const selectBreakpointFeature = createFeatureSelector<BreakpointState>(breakpointFeatureKey);
export const selectBreakpoints = createSelector(selectBreakpointFeature, (state) => state.breakpoints);
export const selectBreakpointActive = (breakpoint: Breakpoint) =>
  createSelector(selectBreakpoints, (breakpoints) => breakpoints[breakpoint]);
